export default __webpack_public_path__ + "static/media/ikon-kotak.8ce90b1e.svg";